/**
 * NOTE: These messages were copied from `src/packages/permissions-administration/pages/users-and-roles/src/common/messages.tsx`
 * to avoid a circular dependency between this package and that one. Remove these messages once the UI components using them
 * are no longer in this package.
 */

import { defineMessages } from '@atlassian/jira-intl';

export const multipleRolesText = defineMessages({
	roleMessage: {
		id: 'feature-gates-tmp-access.common.user-roles.role-message',
		defaultMessage: 'Multiple ({count, plural, one {1 role} other {# roles}})',
		description:
			'Dropdown label shown to user when they have selected multiple roles. {count} refer to number of roles selected',
	},
});
